import { AlertTriangle } from "lucide-react";

import { Button } from "@/components/ui/button";

interface EventsErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export function EventsErrorState({ message, onRetry }: EventsErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-destructive/30 bg-destructive/5 p-12 text-center">
      <AlertTriangle className="mb-3 h-10 w-10 text-destructive" />
      <h3 className="text-base font-semibold">
        Impossibile caricare gli eventi
      </h3>
      <p className="mt-1 max-w-md text-sm text-muted-foreground">
        {message ?? "Si e' verificato un errore durante il caricamento."}
      </p>
      {onRetry ? (
        <Button variant="outline" size="sm" onClick={onRetry} className="mt-4">
          Riprova
        </Button>
      ) : null}
    </div>
  );
}
